import React from 'react'
import { Button, Layout } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'

const { Sider } = Layout

const styles = {
  container: {
    height: '100%',
    position: 'relative',
    transition: 'all 0.2s',
    backgroundColor: '#fff',
  },
  sidebarContent: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '16px',
    transition: 'all 0.2s',
    backgroundColor: '#fff',
  },
  collapsedContent: {
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#fff',
    overflow: 'hidden',
    width: '100%',
  },
  sidebarHandle: {
    position: 'absolute',
    right: -16,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 100,
    width: 16,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    borderRadius: '0 4px 4px 0',
    boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
    border: '1px solid #f0f0f0',
    borderLeft: 'none',
  },
  icon: {
    fontSize: '12px',
  }
}

const ResizableSidebar = ({ children, collapsed, onCollapse, width = 250, collapsedWidth = 80 }) => {
  return (
    <Sider
      width={width}
      collapsedWidth={collapsedWidth}
      collapsed={collapsed}
      trigger={null}
      collapsible
      style={styles.container}
      theme="light"
    >
      <div
        style={collapsed ? styles.collapsedContent : styles.sidebarContent}
        className="custom-scrollbar"
      >
        {collapsed ? null : children}
      </div>
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined style={styles.icon} /> : <MenuFoldOutlined style={styles.icon} />}
        onClick={onCollapse}
        style={styles.sidebarHandle}
      />
    </Sider>
  )
}

export default ResizableSidebar
